import styled from 'styled-components';
import FilterBar from './components/filters/FilterBarPresentation';
import CardsContainer from './components/search-results/CardsContainerPresentation';

interface SearchViewProps {
  loadedSearchResultsSSR: any;
  pageTitle: string;
  launches: any;
}
const SearchView = ({
  loadedSearchResultsSSR,
  pageTitle,
  launches
}: SearchViewProps) => {
  return (
    <SearchLayout>
      <div>
        <FilterBar loadedSearchResultsSSR={loadedSearchResultsSSR} />
        <div className="container-fluid">
          <CardsContainer
            loadedSearchResultsSSR={loadedSearchResultsSSR}
            pageTitle={pageTitle}
            launches={launches}
          />
        </div>
      </div>
    </SearchLayout>
  );
};
const SearchLayout = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  height: max-content;
  padding-bottom: 150px;

  .search-data {
    display: flex;
    flex-direction: column;
    transition: all 0.6s ease-out;
    width: 100%;
  }
`;
export default SearchView;
